import { parse } from 'node-html-parser'

export const useContent = () => {

  const placeholders = [
    /\{(branch-opening)-(\d+)\}/g,
    /\{(youtube-videos)\}/g,
    /\{(dynamicky-doplnene-nejoblibenejsi-znacky)\}/g,
    /\{(dynamicky-doplnene-nove-znacky)\}/g,
    /\{(dynamicky-doplnene-vsechny-znacky)\}/g,
    /\{(hledaci policko)\}/g,
    /\{(photogallery),(\d+)\}/g,
    /\{(cenik-dopravy)\}/g,
    /\{(youtube-video)-(.*)\}/g,
    /\{(map)-(.*)\}/g,
  ];

  // replace placeholders with component names represented as HTML tags
  const replacePlaceholders = (content) => {
    let result = content;

    placeholders.forEach(placeholder => {
      result = result.replaceAll(placeholder, '<$1 id="$2" />');
    });

    result = result.replaceAll(/<hledaci policko/g, '<hledaci-policko');
    result = result.replaceAll(/\r\n/g, '\n');

    return result;
  }

  const mapTransformedContent = (content) => {

    // Recursive case: map each item in the array
    return content.childNodes?.map(item => {

      // If the item is an object, map its values
      if (typeof item === 'object' && item !== null) {
        return {
          nodeType: item.nodeType,
          text: item.text,
          tagName: item.tagName,
          attributes: item.attributes,
          childNodes: mapTransformedContent(item),
        }
      }

      // Otherwise, return the item
      return item;
    });
  }

  const transformParsedContent = (parsedContent, pageId = undefined) => {

    //#region infocenter

    // add navigation panel with anchors to the content
    if (pageId === 26558 && parsedContent.querySelector('.sections ul') && parsedContent.querySelector('.content')) {

      const sections = parsedContent.querySelector('.sections ul');
      const contentHeaders = parsedContent.querySelectorAll('.content h2');

      contentHeaders.forEach((header) => {

        const text = useUtils().slugify(header.text);

        const anchor = parse(`<a href="#${text}">${header.text.trim()}</a>`);
        const listItem = parse(`<li>${anchor}</li>`);
        sections.appendChild(listItem);

        header.setAttribute('data-anchor', text);
      });

    }

    //#endregion

    return parsedContent;
  }

  const transformHtmlContent = (content, pageId = undefined) => {

    const parsedContent = parse(`<div>${replacePlaceholders(content)}</div>`);
    const transformedContent = transformParsedContent(parsedContent, pageId);
    const mappedContent = mapTransformedContent(transformedContent);

    return mappedContent;
  }

  return {
    transformHtmlContent
  }

}